import { FC } from 'react';

import { useViewer } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { GraphQLErrorMessage } from '@treams/treams-ui';

import { growthPathDataMappingFromJobTitle } from '../GrowthPathConverter';
import { useGrowthPathContext } from '../contexts/GrowthPathContext';
import GrowthPathDetailBody, { GrowthPathDetailBodySkeleton } from './GrowthPathDetailBody';
import LabelQueryWrapper from './LabelQueryWrapper';

const CareerDetailBody: FC = () => {
	const viewer = useViewer();

	const { jobTitleID, userID } = useGrowthPathContext();

	const { data, loading, error } = graphql.useJobTitleCompetenciesQuery({
		variables: { id: jobTitleID, userID: userID ?? viewer!.id },
		skip: !jobTitleID || jobTitleID === 'all',
	});

	const jobCompetencies = data?.jobTitle.competencies ?? [];

	if (loading) {
		return <GrowthPathDetailBodySkeleton />;
	}
	if (error) {
		return <GraphQLErrorMessage error={error.graphQLErrors[0]} />;
	}

	return (
		<LabelQueryWrapper jobCompetencies={jobCompetencies} data={data}>
			<GrowthPathDetailBody data={growthPathDataMappingFromJobTitle(data?.jobTitle)} />
		</LabelQueryWrapper>
	);
};
export default CareerDetailBody;
